import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import Report from '../customers/retention/retentionReport';
import {
  fetchShopRetention,
  getRetentionReportCsv,
} from '../customers/retention/actions';
import { activeShopName } from '../../auth/selectors';
import withTimezone from '../../auth/utils/withTimezone';


const mapStateToProps = state => ({
  shop: state.auth.shop,
  shopName: activeShopName(state),
});

const mapDispatchToProps = {
  fetchShopRetention,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  withHandlers({
    getReport: props => (quarter, year, customerRetainedVisitsCount) =>
      props.fetchShopRetention(props.shop, quarter, year, customerRetainedVisitsCount),
    getCsv: props => (quarter, year, customerRetainedVisitsCount) => getRetentionReportCsv({
      shopId: props.shop,
      shopName: props.shopName,
      quarter,
      year,
      timezone: props.timezone,
      customerRetainedVisitsCount,
    }),
  }),
);

export default enhance(Report);
